import { createContext } from "preact";
import { useContext, useState, useEffect } from "preact/hooks";
import type { ComponentChildren } from "preact";
import { useDaily } from "@daily-co/daily-react";

interface MuteContextType {
  isMicMuted: boolean;
  setIsMicMuted: (muted: boolean) => void;
  isAudioMuted: boolean;
  setIsAudioMuted: (muted: boolean) => void;
}

const MuteContext = createContext<MuteContextType | undefined>(undefined);

interface MuteProviderProps {
  children: ComponentChildren;
}

export function MuteProvider({ children }: MuteProviderProps) {
  const [isMicMuted, setIsMicMuted] = useState<boolean>(true);
  const [isAudioMuted, setIsAudioMuted] = useState<boolean>(false);
  const callObject = useDaily();

  useEffect(() => {
    if (callObject) {
      callObject.setLocalAudio(!isMicMuted);
    }
  }, [isMicMuted, callObject]);

  return <MuteContext.Provider value={{ isMicMuted, setIsMicMuted, isAudioMuted, setIsAudioMuted }}>{children}</MuteContext.Provider>;
}

export function useMute(): MuteContextType {
  const context = useContext(MuteContext);
  if (!context) {
    throw new Error("useMute must be used within a MuteProvider");
  }
  return context;
}

